// extracted by mini-css-extract-plugin
export default {"photoViewContainer":"styles_photoViewContainer__AtLZg"};